import React from 'react';

import { useMountEffect } from '@react-hookz/web/esm';

import { Box, useBreakpointIndex } from '@apia/theme';
import SchedulerNavigation, { getCurrentDate } from './SchedulerNavigation';
import ApiaApi, { makeApiaUrl } from '../../../../api/apiaApi/apiaApi';

import { IApiaSchedule, TScheduleResult } from './types';

import SchedulerTable from './SchedulerTable';
import SchedulerMini from './mini/SchedulerMini';
import store from '../../../../store';

import { useAppSelector } from '../../../../hooks/hooks';
import { schedulerActions } from '../../../../store/schedulerSlice';
import makeDaysStage from './mini/utils';
import SelectedDateInfo from './SelectedDate';

const Scheduler: React.FC<IApiaSchedule> = ({
  schId,
  proId,
  proVerId,
  tskId,
  showDisponibility,
  showAttributes,
  weekDayProp,
  url,
}) => {
  const data = useAppSelector((global) => global.schedulerSlice.data);
  const breakPoint = useBreakpointIndex();
  const loadWeekDay = React.useCallback(
    async (weekDay: string) => {
      const result = await ApiaApi.get<TScheduleResult>(
        makeApiaUrl({
          ajaxUrl: url,
          action: 'getExecutionSchedulerWeek',
          weekDay,
          schId,
          proId,
          proVerId,
          tskId,
        }),
      );

      if (result?.data) {
        makeDaysStage(result?.data);
        store.dispatch(schedulerActions.setData(result.data));
        store.dispatch(
          schedulerActions.setState({
            isLoading: 'NotLoading',
            showDisponibility,
            showAttributes,
            overassign: result?.data.overassign,
            url,
          }),
        );
      }
    },

    [proId, proVerId, schId, showAttributes, showDisponibility, tskId, url],
  );

  useMountEffect(() => {
    if (weekDayProp) {
      void loadWeekDay(weekDayProp);
    } else {
      void loadWeekDay(getCurrentDate());
      console.log('getCurrentDate()', getCurrentDate());
    }
  });

  const labelSelectedDay = useAppSelector((global) => {
    return global.schedulerSlice?.labelSelectedDay;
  });

  return (
    <Box
      {...window.getVariant('layout.execution.form.fields.scheduler')}
      className="scheduler"
    >
      <SchedulerNavigation
        onLoadWeekDay={React.useCallback(
          (weekDay) => loadWeekDay(weekDay),
          [loadWeekDay],
        )}
        // currentDate={currentDate}
        mondayWeek={data?.mondayWeek ?? ''}
      />
      <SelectedDateInfo labelSelectedDay={labelSelectedDay} data={data} />
      {breakPoint > 4 ? <SchedulerTable /> : <SchedulerMini />}
    </Box>
  );
};

export default Scheduler;
